export default __webpack_public_path__ + "static/media/jidelna.04678e4c.jpeg";